"use client";
import ProductList from '../../components/product/ProductList';

export default function BedroomCategoryPage() {
  return <ProductList />;
}
